



























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  MentoringCardFooter,
  MentoringSmallText as Small,
} from '../components';
import { MentoringMain } from './components';
import {
  DETAILS,
  ROLLUP,
  OPEN,
  CLOSED,
  REJECTED,
  WORKING,
  UNKNOWN,
} from './consts';
import { StatusEnum, IMentoringRequestCard, FindItem } from './types';

@Component({
  components: {
    Small,
    MentoringMain,
    MentoringCardFooter,
  },
})
export default class MentoringRequestCard
  extends Vue
  implements IMentoringRequestCard {
  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: String, default: '' })
  readonly createDate!: string;

  @Prop({ type: String, default: '' })
  readonly startDate!: string;

  @Prop({ type: String, default: '' })
  readonly endDate!: string;

  public isOpenDescription: boolean = this.index === 0;

  get btnText(): string {
    return this.isOpenDescription ? ROLLUP : DETAILS;
  }

  get statusDictionary() {
    return this.$store.state.RequestStatuses;
  }

  get thisStatus() {
    const { statusDictionary, status } = this;
    const result = statusDictionary.find(
      ({ id }: FindItem) => id.toString() === status
    );
    return result && result.name;
  }

  get statusText(): string {
    const { thisStatus } = this;
    return thisStatus ? thisStatus : UNKNOWN;
  }

  get statuses() {
    switch (this.status) {
      case '1':
        return StatusEnum.OPEN;
      case '2':
        return StatusEnum.WORKING;
      case '3':
        return StatusEnum.CLOSED;
      default:
        return StatusEnum.REJECTED;
    }
  }

  get startText(): string {
    const { status, endDate } = this;
    switch (status) {
      case '1':
      case '2':
        return 'Не завершен';
      case '3':
        return endDate;
      default:
        return '';
    }
  }

  get classColor(): string {
    return `requestcard__span_${this.statuses}`;
  }

  toggleDescription(): void {
    this.isOpenDescription = !this.isOpenDescription;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/requestcard/MentoringRequestCard.vue